// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_5RV","cls2":"FriendlySutdModal-cls2_IAz FriendlySutdModal-cls1_5RV"};